import React, { useEffect, useRef, useState } from 'react';
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  Circle,
} from 'react-google-maps';
import { MarkerClusterer } from 'react-google-maps/lib/components/addons/MarkerClusterer';
import mapStyles from '../utils/mapStyles';
import MapKeys from './MapKeys';

const googleMapOptions = {
  styles: mapStyles,
  streetViewControl: false,
  mapTypeControl: false,
  zoomControl: true,
  zoomControlOptions: {
    position: 6,
  },
  fullscreenControl: false,
};

const GMap = withScriptjs(
  withGoogleMap(
    ({
      defaultCenter,
      markers,
      isLocationSearch,
      distance,
      handleMarkerClick,
      loading,
    }) => {
      const [activeMarker, setActiveMarker] = useState(null);
      const [bounceMarker, setBounceMarker] = useState(0);

      const distanceInMeters = distance * 1609.344;

      const mapRef = useRef(null);
      const circleRef = useRef(null);

      const fitBounds = () => {
        const bounds = new window.google.maps.LatLngBounds();
        if (markers.length >= 1) {
          markers.forEach((item) => {
            bounds.extend({
              lat: +item.location.lat,
              lng: +item.location.lng,
            });
          });
        }

        if (circleRef.current) {
          mapRef.current.fitBounds(circleRef.current.getBounds());
        } else {
          mapRef.current.fitBounds(bounds);
        }
      };

      useEffect(() => {
        fitBounds();
        setActiveMarker(null);
      }, [markers]);

      const displayMarker = (item) => {
        const newViewportWidth =
          window.innerWidth || document.documentElement.clientWidth;
        if (newViewportWidth) {
          if (item.id === activeMarker && item.coming_soon) {
            return '/app/themes/adaptable/src/assets/images/gold_map_icon.svg';
          }
          if (item.id === activeMarker && !item.coming_soon) {
            return '/app/themes/adaptable/src/assets/images/gold_map_icon.svg';
          }
          if (item.coming_soon) {
            return '/app/themes/adaptable/src/assets/images/coming_soon_icon.svg';
          }
        }

        return '/app/themes/adaptable/src/assets/images/map_icon.svg';
      };

      const returnBounceAnimation = (item) => {
        if (item.id === bounceMarker) {
          setTimeout(() => {
            setBounceMarker(0);
          }, 1000);
          return google.maps.Animation.BOUNCE;
        }
      };

      const clusterStyles = [
        {
          textColor: 'white',
          url: '/app/themes/adaptable/src/assets/images/cluster_icon.svg',
          height: 68,
          width: 68,
        },
      ];

      return (
        <GoogleMap
          ref={mapRef}
          center={defaultCenter}
          options={googleMapOptions}
        >
          <MapKeys />
          {!loading && (
            <MarkerClusterer
              averageCenter
              enableRetinaIcons
              gridSize={60}
              styles={clusterStyles}
            >
              {markers.map((marker, index) => (
                <Marker
                  key={`marker_${index}`}
                  onClick={() => {
                    setBounceMarker(marker.id);
                    setActiveMarker(marker.id);
                    handleMarkerClick(marker.id);
                  }}
                  animation={returnBounceAnimation(marker)}
                  icon={displayMarker(marker)}
                  position={{
                    lat: marker.location.lat,
                    lng: marker.location.lng,
                  }}
                />
              ))}
            </MarkerClusterer>
          )}
          {isLocationSearch && (
            <Circle
              ref={circleRef}
              center={defaultCenter}
              radius={distanceInMeters}
              visible
              options={{
                fillOpacity: 0.04,
                fillColor: '#000000',
                strokeWeight: 1,
                strokeColor: '#DEDEDE',
              }}
            />
          )}
          {isLocationSearch && (
            <Marker
              icon="/app/themes/adaptable/src/assets/images/your_location_icon.svg"
              position={defaultCenter}
            />
          )}
        </GoogleMap>
      );
    }
  )
);

export default GMap;
